<div class="notifications" [class.game-header]="isGameHeader()" [ngClass]="{
    'open': notification.dropdownOpen
  }">
  <div class="notifications__top">
    <i (click)="notification.close()" class="icon-close"></i>
    <div class="notifications__top--counter">
      <div class="notifications__title">{{'t.notifications' | translate}}</div>
      <span [ngClass]="{opened: notification.isOpened}" class="notifications__count">{{lists().length || 0}}</span>
    </div>
  </div>
  <div class="notifications__list" [class.more]="isGameHeader() && notification.isShowMore()">
    @for (notify of lists() | slice:0: isGameHeader() && !notification.isShowMore() ? 2 : lists()?.length; track $index) {
      <app-notification-center-item [notify]="notify"></app-notification-center-item>
    }
    @if (isGameHeader() && !notification.isShowMore() && lists().length > 2) {
      <div class="notifications__more flex flex-center pb-20 pt-6 text-12 cursor-pointer" (click)="notification.isShowMore.set(true)">{{ 't.show-more' | translate }}</div>
    }
  </div>
</div>
